export default "__VITE_ASSET__76de036d__"